export const SERVER_URL: string = process.env.REACT_APP_SERVER_URL as string;